import React, { FC } from 'react'
import { tawreedTranslationService } from '../../../../../common/translations';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { OrderForm } from './order-form/order-form';

export interface OrderFormDialogProps {
    visible: boolean;
    orderId: number;
    hide: () => void;
}
export const OrderFormDialog: FC<OrderFormDialogProps> = ({ orderId, hide,visible }) => {
    const ImportProductsDialogFooter = () => {
        return (<div>
            <Button label={tawreedTranslationService.translate('lbl_cancel')} icon="pi pi-times" onClick={hide} className="p-button-text" disabled={false} />
        </div>);
    }

    return (
        <Dialog style={{ minWidth: '50%' }} header={""}
         visible={visible} footer={<ImportProductsDialogFooter />} onHide={hide} draggable={false}
          position="top" closable={true} closeOnEscape={true}>
            { <OrderForm orderId={orderId ?? undefined} showControl={false}/>}
        </Dialog>
    )
}